export const INTERESTED_FIELDS_OPTIONS = [
  "Artificial Intelligence (AI)",
  "Machine Learning",
  "Generative AI",
  "Data Science",
  "Data Analytics",
  "Big Data",
  "Blockchain",
  "Web3",
  "Cryptocurrency",
  "Cybersecurity",
  "Cloud Computing",
  "DevOps",
  "Software Development",
  "Enterprise SaaS",
  "Consumer Tech",
  "Mobile Apps",
  "Robotics",
  "Internet of Things (IoT)",
  "AR/VR",
  "Quantum Computing",
  "FinTech",
  "InsurTech",
  "WealthTech",
  "Venture Capital",
  "Private Equity",
  "Angel Investing",
  "E-commerce",
  "Direct-to-Consumer (D2C)",
  "Retail",
  "Digital Marketing",
  "Advertising",
  "Influencer Marketing",
  "Content Creation",
  "Creator Economy",

  "HealthTech",
  "MedTech",
  "Biotechnology",
  "Pharmaceuticals",
  "AgriTech",
  "FoodTech",
  "GreenTech",
  "CleanTech",
  "Sustainability",
  "Renewable Energy",
  "Climate Tech",

  "Manufacturing",
  "Industry 4.0",
  "Logistics",
  "Supply Chain",
  "Mobility",
  "Electric Vehicles (EV)",
  "Transportation",
  "Real Estate",
  "PropTech",
  "Construction",
  "Infrastructure",
  "Telecommunications",

  "EdTech",
  "Education",
  "HRTech",
  "Future of Work",
  "LegalTech",
  "GovTech",
  "Public Sector",
  "Social Impact",
  "Nonprofits",
  "Travel Tech",
  "Hospitality",

  "Gaming",
  "Esports",
  "Entertainment",
  "SportsTech",
  "Fashion",
  "Consumer Goods",
  "Food & Beverage",
  "Smart Home",
  "Personal Finance",

  "SpaceTech",
  "Aerospace",
  "Defense",
  "Research",
  "DeepTech",
  "Open Source",
  "Developer Tools",
  "Others"
];
